(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[63432],{

/***/ 79542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Accounts"
}); /*END_META*/ 


/***/ }),

/***/ 46711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Adding Custom Styles"
}); /*END_META*/ 


/***/ }),

/***/ 54783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "App customisation"
}); /*END_META*/ 


/***/ }),

/***/ 29822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Features available in tradly apps"
}); /*END_META*/ 


/***/ }),

/***/ 5546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Appstore Setup"
}); /*END_META*/ 


/***/ }),

/***/ 68333:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Attributes"
}); /*END_META*/ 


/***/ }),

/***/ 58981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Auth Systems"
}); /*END_META*/ 


/***/ }),

/***/ 81056:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Branch Metrics"
}); /*END_META*/ 


/***/ }),

/***/ 40494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{}); /*END_META*/ 


/***/ }),

/***/ 52041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Category"
}); /*END_META*/ 


/***/ }),

/***/ 45562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "In-built Chat"
}); /*END_META*/ 


/***/ }),

/***/ 96664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Launch Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 97621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deploying web apps in Cloudflare"
}); /*END_META*/ 


/***/ }),

/***/ 31306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Collections"
}); /*END_META*/ 


/***/ }),

/***/ 65285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Core Concepts"
}); /*END_META*/ 


/***/ }),

/***/ 93878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Commission"
}); /*END_META*/ 


/***/ }),

/***/ 87302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Composer"
}); /*END_META*/ 


/***/ }),

/***/ 44221:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Coupon"
}); /*END_META*/ 


/***/ }),

/***/ 33864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Crowdfunding"
}); /*END_META*/ 


/***/ }),

/***/ 52555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Multi Currencies"
}); /*END_META*/ 


/***/ }),

/***/ 30313:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deeplinks"
}); /*END_META*/ 


/***/ }),

/***/ 54001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Delivery Methods"
}); /*END_META*/ 


/***/ }),

/***/ 74765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 16112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Domain Setup"
}); /*END_META*/ 


/***/ }),

/***/ 26490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Creating Dynamic Pages"
}); /*END_META*/ 


/***/ }),

/***/ 49375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Editing Page Styles in Tradly"
}); /*END_META*/ 


/***/ }),

/***/ 90351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Editor Basic Overview"
}); /*END_META*/ 


/***/ }),

/***/ 18693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Solving Education"
}); /*END_META*/ 


/***/ }),

/***/ 56202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Email Setup"
}); /*END_META*/ 


/***/ }),

/***/ 83073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Discovery / Mobility Solutions"
}); /*END_META*/ 


/***/ }),

/***/ 72512:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Facebook App"
}); /*END_META*/ 


/***/ }),

/***/ 82471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Firebase"
}); /*END_META*/ 


/***/ }),

/***/ 54309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Food Ecosystem"
}); /*END_META*/ 


/***/ }),

/***/ 56638:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Google Analytics"
}); /*END_META*/ 


/***/ }),

/***/ 79015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Google Maps"
}); /*END_META*/ 


/***/ }),

/***/ 89270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Growth Checklist"
}); /*END_META*/ 


/***/ }),

/***/ 2784:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Integrations FAQ"
}); /*END_META*/ 


/***/ }),

/***/ 532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Inventory / Stocks"
}); /*END_META*/ 


/***/ }),

/***/ 91662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Signing up for Karix and Using as SMS gateway"
}); /*END_META*/ 


/***/ }),

/***/ 19660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Multi Language"
}); /*END_META*/ 


/***/ }),

/***/ 30435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Listings"
}); /*END_META*/ 


/***/ }),

/***/ 44080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Geo Location"
}); /*END_META*/ 


/***/ }),

/***/ 45708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "MangoPay"
}); /*END_META*/ 


/***/ }),

/***/ 35857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Media"
}); /*END_META*/ 


/***/ }),

/***/ 88619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Setting Up Negotiations"
}); /*END_META*/ 


/***/ }),

/***/ 90519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Netlify"
}); /*END_META*/ 


/***/ }),

/***/ 57767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Notifications"
}); /*END_META*/ 


/***/ }),

/***/ 66625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Online Payment Platform"
}); /*END_META*/ 


/***/ }),

/***/ 38714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Order & Checkout Methods"
}); /*END_META*/ 


/***/ }),

/***/ 51157:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Solutions Ideas"
}); /*END_META*/ 


/***/ }),

/***/ 96968:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": 'PayDunya"'
}); /*END_META*/ 


/***/ }),

/***/ 86890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Payment Methods"
}); /*END_META*/ 


/***/ }),

/***/ 69382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Playstore Setup"
}); /*END_META*/ 


/***/ }),

/***/ 64703:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Different Products"
}); /*END_META*/ 


/***/ }),

/***/ 80180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Promotion"
}); /*END_META*/ 


/***/ }),

/***/ 56090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Q&A - Comments"
}); /*END_META*/ 


/***/ }),

/***/ 14871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Razorpay"
}); /*END_META*/ 


/***/ }),

/***/ 14427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Deploying web apps in Render"
}); /*END_META*/ 


/***/ }),

/***/ 55181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Analytics Features"
}); /*END_META*/ 


/***/ }),

/***/ 96831:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Revenue Model"
}); /*END_META*/ 


/***/ }),

/***/ 16132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Review and Ratings"
}); /*END_META*/ 


/***/ }),

/***/ 76347:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Booking Schedules"
}); /*END_META*/ 


/***/ }),

/***/ 53410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Customizing Screens",
    "shortTitle": "Screens"
}); /*END_META*/ 


/***/ }),

/***/ 85485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Search & Filters"
}); /*END_META*/ 


/***/ }),

/***/ 63466:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "SEO"
}); /*END_META*/ 


/***/ }),

/***/ 12952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Checklist for Mobile Apps"
}); /*END_META*/ 


/***/ }),

/***/ 92787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Social Feed"
}); /*END_META*/ 


/***/ }),

/***/ 20441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Connect"
}); /*END_META*/ 


/***/ }),

/***/ 70232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Onboarding"
}); /*END_META*/ 


/***/ }),

/***/ 2029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stripe Payments"
}); /*END_META*/ 


/***/ }),

/***/ 84873:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Stuart Delivery"
}); /*END_META*/ 


/***/ }),

/***/ 13002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Submitting Template to the Tradly Marketplace"
}); /*END_META*/ 


/***/ }),

/***/ 41476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Subscription revenue model"
}); /*END_META*/ 


/***/ }),

/***/ 8380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{}); /*END_META*/ 


/***/ }),

/***/ 30526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Taxation"
}); /*END_META*/ 


/***/ }),

/***/ 20160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Template Creation"
}); /*END_META*/ 


/***/ }),

/***/ 43927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Test Apps"
}); /*END_META*/ 


/***/ }),

/***/ 66147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Custom Event Tracking"
}); /*END_META*/ 


/***/ }),

/***/ 66730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Translations"
}); /*END_META*/ 


/***/ }),

/***/ 30896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Signing up for Twilio and Using as SMS gateway"
}); /*END_META*/ 


/***/ }),

/***/ 23237:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Users"
}); /*END_META*/ 


/***/ }),

/***/ 1156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Variants"
}); /*END_META*/ 


/***/ }),

/***/ 12029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Vercel Deployment"
}); /*END_META*/ 


/***/ }),

/***/ 23816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Account Wallet"
}); /*END_META*/ 


/***/ }),

/***/ 71182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Webhook"
}); /*END_META*/ 


/***/ }),

/***/ 84368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Things to setup in your website"
}); /*END_META*/ 


/***/ }),

/***/ 17207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Wishlist"
}); /*END_META*/ 


/***/ }),

/***/ 79390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (/*START_META*/{
    "title": "Zapier"
}); /*END_META*/ 


/***/ }),

/***/ 55390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vw": function() { return /* binding */ TipGood; },
/* harmony export */   "qm": function() { return /* binding */ TipBad; }
/* harmony export */ });
/* unused harmony exports TipCompat, TipInfo */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function TipGood(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-start my-6 space-x-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative mt-1 w-4 h-4 rounded-full bg-cyan-500 text-white flex items-center justify-center ring-2 ring-cyan-500",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "6",
                        height: "4.5",
                        className: "overflow-visible",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M6 0L2 4.5L0 2.5",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-full mt-1 left-[0.46875rem] w-px h-[1.375rem] bg-cyan-500/30 rounded-full"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "m-0 flex-1 text-base font-semibold text-gray-900",
                children: children
            })
        ]
    });
}
function TipBad(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-start my-6 space-x-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "relative mt-1 w-4 h-4 rounded-full bg-rose-400 text-white flex items-center justify-center ring-2 ring-rose-400",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                        width: "6",
                        height: "6",
                        className: "overflow-visible",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M0 0L6 6M6 0L0 6",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "absolute top-full mt-1 left-[0.46875rem] w-px h-[1.375rem] bg-rose-200 rounded-full"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "m-0 flex-1 text-base font-semibold text-gray-900",
                children: children
            })
        ]
    });
}
function TipCompat(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: "text-sm bg-light-blue-100 text-light-blue-800 font-medium px-4 py-3 mb-4 rounded-xl",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex items-start space-x-3",
            children: [
                /*#__PURE__*/ _jsx("svg", {
                    width: "20",
                    height: "20",
                    className: "text-light-blue-500",
                    fill: "currentColor",
                    children: /*#__PURE__*/ _jsx("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M6.998 2a1 1 0 00-.707 1.707l.707.707v3.758a1 1 0 01-.293.707l-4 4C.815 14.769 2.154 18 4.826 18H15.17c2.672 0 4.01-3.231 2.12-5.121l-4-4a1 1 0 01-.292-.707V4.414l.707-.707A1 1 0 0012.998 2h-6zm2 6.172V4h2v4.172a3 3 0 00.879 2.12l1.027 1.028a4 4 0 00-2.171.102l-.47.156a4 4 0 01-2.53 0l-.563-.187a1.992 1.992 0 00-.114-.035l1.063-1.063a3 3 0 00.879-2.121z"
                    })
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "flex-1",
                    children: children
                })
            ]
        })
    });
}
function TipInfo(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsxs("div", {
        className: "not-prose mt-6 -mb-1 flex space-x-2",
        children: [
            /*#__PURE__*/ _jsx("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                className: "flex-none w-5 h-5 text-gray-400",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                children: /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                    clipRule: "evenodd"
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-gray-700 text-sm font-medium",
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 53339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ DocumentationLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21744);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _img_tradly_Tradly_MEta_image_png__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52066);
/* harmony import */ var _components_Title__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68224);
/* harmony import */ var _navs_documentation__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54713);








function DocumentationLayout(props) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Title__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .D, {
                suffix: router.pathname === "/" ? undefined : "Tradly",
                children: props.layoutProps.meta.metaTitle || props.layoutProps.meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary"
                    }, "twitter:card"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://tradly.app".concat(_img_tradly_Tradly_MEta_image_png__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)
                    }, "twitter:image"),
                    props.layoutProps.meta.canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: props.layoutProps.meta.canonical
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_SidebarLayout__WEBPACK_IMPORTED_MODULE_1__/* .SidebarLayout */ .C, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                nav: _navs_documentation__WEBPACK_IMPORTED_MODULE_5__/* .documentationNav */ .u
            }, props))
        ]
    });
}
DocumentationLayout.nav = _navs_documentation__WEBPACK_IMPORTED_MODULE_5__/* .documentationNav */ .u;


/***/ }),

/***/ 54713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "u": function() { return /* binding */ documentationNav; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/utils/importAll.js
function importAll(r) {
    return r.keys().map(function(fileName) {
        return {
            fileName: fileName,
            module: r(fileName)
        };
    });
}

;// CONCATENATED MODULE: ./src/utils/createPageList.js




function createPageList(files, base) {
    return importAll(files).reduce(function(acc, cur) {
        var slug = cur.fileName.substr(2).replace(/\.mdx$/, "");
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, acc), (0,_define_property/* default */.Z)({}, slug, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cur.module.default), {
            href: "/".concat(base, "/").concat(slug)
        })));
    }, {});
}

;// CONCATENATED MODULE: ./src/navs/documentation.js

var pages = createPageList(__webpack_require__(66708), "docs");
var documentationNav = {
    "Getting Started": [
        {
            title: "Setup",
            href: "/docs/setup",
            match: /^\/docs\/setup/
        },
        pages["commerce-definitions"],
        pages["checklist"],
        pages["appcustomisation"],
        pages["testingapp"],
        pages["products"],
        pages["translations"], 
    ],
    "Building Blocks": [
        pages["users"],
        pages["listings"],
        pages["attributes"],
        pages["variants"],
        pages["category"],
        pages["media"],
        pages["review-ratings"],
        pages["location"],
        pages["schedules"],
        pages["search"],
        pages["tags"],
        pages["wishlist"],
        pages["qa-comments"],
        pages["notifications"],
        pages["negotiations"],
        pages["inventory"], 
    ],
    Marketing: [
        pages["collection"],
        pages["promotion"],
        pages["coupon"],
        pages["seo"],
        pages["tracking"], 
    ],
    "Marketplace & Platform": [
        pages["accounts"],
        pages["wallet"],
        pages["chat"],
        pages["social"]
    ],
    "Business Blocks": [
        pages["delivery"],
        pages["paymentgateways"],
        pages["revenuemodel"],
        pages["commission"],
        pages["order"],
        pages["tax"], 
    ],
    "System Blocks": [
        pages["auth"],
        pages["language"],
        pages["currency"],
        pages["email"],
        pages["domain"], 
    ],
    "Editor Guides": [
        pages["template-create"],
        pages["editor-overview"],
        pages["editing-page-styles"],
        pages["dynamic-page"],
        pages["submit-template"], 
    ],
    Deployment: [
        pages["deployment"],
        pages["playstore"],
        pages["appstore"],
        pages["vercel"],
        pages["netlify"], 
    ],
    "Native Integrations": [
        pages["integrations-overview"],
        pages["webhook"],
        pages["zapier"],
        pages["firebase"],
        pages["stripe-payments"],
        pages["stripe-connect"],
        pages["stripe-onboarding"],
        pages["mangopay"],
        pages["onlinepaymentplatform"],
        pages["stuart"],
        pages["branch"],
        pages["google-maps"],
        pages["ga"],
        pages["facebookapp"], 
    ],
    "Solution - UNSDG Goals": [
        pages["crowdfunding"],
        pages["food"],
        pages["education"],
        pages["energy"],
        pages["othersolutions"], 
    ]
};


/***/ }),

/***/ 66708:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./accounts.mdx": 79542,
	"./adding-custom-styles.mdx": 46711,
	"./appcustomisation.mdx": 54783,
	"./appfeatures.mdx": 29822,
	"./appstore.mdx": 5546,
	"./attributes.mdx": 68333,
	"./auth.mdx": 58981,
	"./branch.mdx": 81056,
	"./build-marketplace.mdx": 40494,
	"./category.mdx": 52041,
	"./chat.mdx": 45562,
	"./checklist.mdx": 96664,
	"./cloudflare.mdx": 97621,
	"./collection.mdx": 31306,
	"./commerce-definitions.mdx": 65285,
	"./commission.mdx": 93878,
	"./composer.mdx": 87302,
	"./coupon.mdx": 44221,
	"./crowdfunding.mdx": 33864,
	"./currency.mdx": 52555,
	"./deeplinks.mdx": 30313,
	"./delivery.mdx": 54001,
	"./deployment.mdx": 74765,
	"./domain.mdx": 16112,
	"./dynamic-page.mdx": 26490,
	"./editing-page-styles.mdx": 49375,
	"./editor-overview.mdx": 90351,
	"./education.mdx": 18693,
	"./email.mdx": 56202,
	"./energy.mdx": 83073,
	"./facebookapp.mdx": 72512,
	"./firebase.mdx": 82471,
	"./food.mdx": 54309,
	"./ga.mdx": 56638,
	"./google-maps.mdx": 79015,
	"./growth.mdx": 89270,
	"./integrations-overview.mdx": 2784,
	"./inventory.mdx": 532,
	"./karix.mdx": 91662,
	"./language.mdx": 19660,
	"./listings.mdx": 30435,
	"./location.mdx": 44080,
	"./mangopay.mdx": 45708,
	"./media.mdx": 35857,
	"./negotiations.mdx": 88619,
	"./netlify.mdx": 90519,
	"./notifications.mdx": 57767,
	"./onlinepaymentplatform.mdx": 66625,
	"./order.mdx": 38714,
	"./othersolutions.mdx": 51157,
	"./paydunya.mdx": 96968,
	"./paymentgateways.mdx": 86890,
	"./playstore.mdx": 69382,
	"./products.mdx": 64703,
	"./promotion.mdx": 80180,
	"./qa-comments.mdx": 56090,
	"./razorpay.mdx": 14871,
	"./render.mdx": 14427,
	"./reports.mdx": 55181,
	"./revenuemodel.mdx": 96831,
	"./review-ratings.mdx": 16132,
	"./schedules.mdx": 76347,
	"./screens.mdx": 53410,
	"./search.mdx": 85485,
	"./seo.mdx": 63466,
	"./setup-app.mdx": 12952,
	"./social.mdx": 92787,
	"./stripe-connect.mdx": 20441,
	"./stripe-onboarding.mdx": 70232,
	"./stripe-payments.mdx": 2029,
	"./stuart.mdx": 84873,
	"./submit-template.mdx": 13002,
	"./subscription.mdx": 41476,
	"./tags.mdx": 8380,
	"./tax.mdx": 30526,
	"./template-create.mdx": 20160,
	"./testingapp.mdx": 43927,
	"./tracking.mdx": 66147,
	"./translations.mdx": 66730,
	"./twilio.mdx": 30896,
	"./users.mdx": 23237,
	"./variants.mdx": 1156,
	"./vercel.mdx": 12029,
	"./wallet.mdx": 23816,
	"./webhook.mdx": 71182,
	"./website.mdx": 84368,
	"./wishlist.mdx": 17207,
	"./zapier.mdx": 79390,
	"src/pages/docs/accounts.mdx": 79542,
	"src/pages/docs/adding-custom-styles.mdx": 46711,
	"src/pages/docs/appcustomisation.mdx": 54783,
	"src/pages/docs/appfeatures.mdx": 29822,
	"src/pages/docs/appstore.mdx": 5546,
	"src/pages/docs/attributes.mdx": 68333,
	"src/pages/docs/auth.mdx": 58981,
	"src/pages/docs/branch.mdx": 81056,
	"src/pages/docs/build-marketplace.mdx": 40494,
	"src/pages/docs/category.mdx": 52041,
	"src/pages/docs/chat.mdx": 45562,
	"src/pages/docs/checklist.mdx": 96664,
	"src/pages/docs/cloudflare.mdx": 97621,
	"src/pages/docs/collection.mdx": 31306,
	"src/pages/docs/commerce-definitions.mdx": 65285,
	"src/pages/docs/commission.mdx": 93878,
	"src/pages/docs/composer.mdx": 87302,
	"src/pages/docs/coupon.mdx": 44221,
	"src/pages/docs/crowdfunding.mdx": 33864,
	"src/pages/docs/currency.mdx": 52555,
	"src/pages/docs/deeplinks.mdx": 30313,
	"src/pages/docs/delivery.mdx": 54001,
	"src/pages/docs/deployment.mdx": 74765,
	"src/pages/docs/domain.mdx": 16112,
	"src/pages/docs/dynamic-page.mdx": 26490,
	"src/pages/docs/editing-page-styles.mdx": 49375,
	"src/pages/docs/editor-overview.mdx": 90351,
	"src/pages/docs/education.mdx": 18693,
	"src/pages/docs/email.mdx": 56202,
	"src/pages/docs/energy.mdx": 83073,
	"src/pages/docs/facebookapp.mdx": 72512,
	"src/pages/docs/firebase.mdx": 82471,
	"src/pages/docs/food.mdx": 54309,
	"src/pages/docs/ga.mdx": 56638,
	"src/pages/docs/google-maps.mdx": 79015,
	"src/pages/docs/growth.mdx": 89270,
	"src/pages/docs/integrations-overview.mdx": 2784,
	"src/pages/docs/inventory.mdx": 532,
	"src/pages/docs/karix.mdx": 91662,
	"src/pages/docs/language.mdx": 19660,
	"src/pages/docs/listings.mdx": 30435,
	"src/pages/docs/location.mdx": 44080,
	"src/pages/docs/mangopay.mdx": 45708,
	"src/pages/docs/media.mdx": 35857,
	"src/pages/docs/negotiations.mdx": 88619,
	"src/pages/docs/netlify.mdx": 90519,
	"src/pages/docs/notifications.mdx": 57767,
	"src/pages/docs/onlinepaymentplatform.mdx": 66625,
	"src/pages/docs/order.mdx": 38714,
	"src/pages/docs/othersolutions.mdx": 51157,
	"src/pages/docs/paydunya.mdx": 96968,
	"src/pages/docs/paymentgateways.mdx": 86890,
	"src/pages/docs/playstore.mdx": 69382,
	"src/pages/docs/products.mdx": 64703,
	"src/pages/docs/promotion.mdx": 80180,
	"src/pages/docs/qa-comments.mdx": 56090,
	"src/pages/docs/razorpay.mdx": 14871,
	"src/pages/docs/render.mdx": 14427,
	"src/pages/docs/reports.mdx": 55181,
	"src/pages/docs/revenuemodel.mdx": 96831,
	"src/pages/docs/review-ratings.mdx": 16132,
	"src/pages/docs/schedules.mdx": 76347,
	"src/pages/docs/screens.mdx": 53410,
	"src/pages/docs/search.mdx": 85485,
	"src/pages/docs/seo.mdx": 63466,
	"src/pages/docs/setup-app.mdx": 12952,
	"src/pages/docs/social.mdx": 92787,
	"src/pages/docs/stripe-connect.mdx": 20441,
	"src/pages/docs/stripe-onboarding.mdx": 70232,
	"src/pages/docs/stripe-payments.mdx": 2029,
	"src/pages/docs/stuart.mdx": 84873,
	"src/pages/docs/submit-template.mdx": 13002,
	"src/pages/docs/subscription.mdx": 41476,
	"src/pages/docs/tags.mdx": 8380,
	"src/pages/docs/tax.mdx": 30526,
	"src/pages/docs/template-create.mdx": 20160,
	"src/pages/docs/testingapp.mdx": 43927,
	"src/pages/docs/tracking.mdx": 66147,
	"src/pages/docs/translations.mdx": 66730,
	"src/pages/docs/twilio.mdx": 30896,
	"src/pages/docs/users.mdx": 23237,
	"src/pages/docs/variants.mdx": 1156,
	"src/pages/docs/vercel.mdx": 12029,
	"src/pages/docs/wallet.mdx": 23816,
	"src/pages/docs/webhook.mdx": 71182,
	"src/pages/docs/website.mdx": 84368,
	"src/pages/docs/wishlist.mdx": 17207,
	"src/pages/docs/zapier.mdx": 79390
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66708;

/***/ })

}]);